import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import { PUM_TARGET } from '../../../../../Widgets/DataPainterWidget/PowerUsageMonthWidget/powerUsageMonthConst';
import commandEngine from './CommandEngine';
import { CMD_POWERUSAGEMONTH_REGISTRY_KEY, META_TYPE, META_VER } from './powerUsageMonthCommandRegisteryType';

/**
 * Registers the /powermonth command with the CommandEngine.
 * /powermonth — opens/refocuses the power usage per month card (single instance, target=powerMonth).
 */
export function registerPowerUsageMonthCommand() {
    commandEngine.register('/powermonth', {
        hint: 'open power usage per month card (import, export, costs)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_POWERUSAGEMONTH_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: PUM_TARGET }, { rk: PUM_TARGET });
        },
    });
}
